import { render, staticRenderFns } from "./selectExportTypeFooter.vue?vue&type=template&id=38ce21d4"
import script from "./selectExportTypeFooter.vue?vue&type=script&lang=js"
export * from "./selectExportTypeFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports